export default "__VITE_ASSET__CyekR038__"